exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/nls/widget.js-WebpackMultiOutput";